<template>
  <section 
    class="categories-bar flex justify-around py-5"
    :class="{ 'categories-bar-hidden': hideOnScroll }"
  >
    <nav
      class="categories-bar_info max-width-main-container"
      :aria-label="$t('wegow.arias.topNavbar.sectionNavbar')"
    >
      <div :class="{ selected: showTypeOptions === 'concerts' }">
        <div class="title-option" @click="changeSection('concerts')">
          {{ $t("general.header.concerts").toUpperCase() }}
        </div>
        <div v-if="showTypeOptions === 'concerts'" ref="dropdownRef">
          <navbar-dropdown type-section="concerts" />
        </div>
      </div>
      <div :class="{ selected: showTypeOptions === 'festivals' }">
        <div class="title-option" @click="changeSection('festivals')">
          {{ $t("general.header.festivals").toUpperCase() }}
        </div>
        <div v-if="showTypeOptions === 'festivals'" ref="dropdownRef">
          <navbar-dropdown type-section="festivals" />
        </div>
      </div>
      <div :class="{ selected: showTypeOptions === 'ciclos' }">
        <div class="title-option" @click="changeSection('ciclos')">
          {{ $t("general.header.ciclos").toUpperCase() }}
        </div>
        <div v-if="showTypeOptions === 'ciclos'" ref="dropdownRef">
          <navbar-dropdown type-section="ciclos" />
        </div>
      </div>
      <div :class="{ selected: showTypeOptions === 'artists' }">
        <div class="title-option" @click="changeSection('artists')">
          {{ $t("general.header.artists").toUpperCase() }}
        </div>
        <div v-if="showTypeOptions === 'artists'" ref="dropdownRef">
          <navbar-dropdown type-section="artists" :show-cities="false" />
        </div>
      </div>
      <div :class="{ selected: showTypeOptions === 'venues' }">
        <div class="title-option" @click="changeSection('venues')">
          {{ $t("general.header.venues").toUpperCase() }}
        </div>
        <div v-if="showTypeOptions === 'venues'" ref="dropdownRef">
          <navbar-dropdown type-section="venues" :show-genres="false" />
        </div>
      </div>
    </nav>
  </section>
</template>

<script setup>
import NavbarDropdown from "@/components/general/ui/navbar/NavbarDropdown";

import { ref } from "vue";
import useDetectOutsideClick from "@/plugins/useDetectOutsideClick";
import { useScrollHide } from "@/composables/useScrollHide";

const dropdownRef = ref();
const showTypeOptions = ref("");
const opening = ref("");
const { hideOnScroll } = useScrollHide(132); // Umbral de 132px (header + categories bar)

const changeSection = section => {
  if (showTypeOptions.value === section) {
    showTypeOptions.value = "";
  } else {
    showTypeOptions.value = section;
    opening.value = section;
    sendGa(section);
  }
};

useDetectOutsideClick(dropdownRef, () => {
  if (!opening.value) {
    showTypeOptions.value = "";
  } else {
    opening.value = null;
  }
});

const sendGa = label => {
  // if (this.$gtag && typeof this.$gtag.event === "function")
  //   this.$gtag.event("click", {
  //     event_category: label
  //   });
};
</script>

<style scoped lang="scss">
.categories-bar {
  position: sticky;
  top: 72px;
  z-index: 9;
  background-color: $backgroundBlack;
  transform: translateY(0);
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
  opacity: 1;
  
  &.categories-bar-hidden {
    transform: translateY(-100%);
    opacity: 0;
    pointer-events: none;
  }
  
  .categories-bar_info {
    display: flex;
    justify-content: space-around;
  }
  .title-option {
    cursor: pointer;
  }
}
@media screen and (max-width: 768px) {
  .categories-bar {
    display: none;
  }
}
</style>
